"use client";
import type { AppProps } from "next/app";
import Head from "next/head";
import { Provider as ReduxProvider } from "react-redux";
import { ToastContainer } from "react-toastify";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

import Layout from "@/Layout";
import styles from "@/PageCommunities/MainContent/AddressTable/AddressTable.module.scss";
import { ModalProvider } from "@/PartModal/PartModal";
import { ServiceInitializer } from "@/PartServiceInitializer";
import { store } from "@/store/store";
import "@/styles/globals.scss";

export default function App({ Component, pageProps }: AppProps) {
  return (
    <>
      <Head>
        <title>Circular materials</title>
        <meta name="description" content="" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.png" />
      </Head>

      <ReduxProvider store={store}>
        <ServiceInitializer>
          <ModalProvider>
            <Layout>
              <Component {...pageProps} />
            </Layout>
          </ModalProvider>
        </ServiceInitializer>
      </ReduxProvider>
      <Tooltip
        anchorSelect={".notImplementedTooltip"}
        className={styles.tooltip}
        place="top"
      >
        Not clickable, still in development
      </Tooltip>
      <ToastContainer autoClose={15000} />
    </>
  );
}
